function waitForBundler() {
    let bundlerWidget = document.querySelector(".bndlr-volume-discount");

    if (bundlerWidget) {
        console.log("✅ Bundler widget detected. Applying custom script...");
        setTimeout(applyCustomBundlerLogic, 1000);
    } else {
        console.log("⏳ Waiting for Bundler to load...");
        setTimeout(waitForBundler, 500);
    }
}

function applyCustomBundlerLogic() {
    let originalPriceElement = document.querySelector(".f-price-item--regular");

    if (!originalPriceElement) {
        console.error("❌ Original price element not found.");
        return;
    }

    let originalPrice = parseFloat(originalPriceElement.textContent.replace(/[^0-9.]/g, ""));

    if (isNaN(originalPrice)) {
        console.error("❌ Failed to retrieve original price.");
        return;
    }

    document.querySelectorAll(".bndlr-volume-discount").forEach(function (box) {
        box.style.cursor = "pointer";

        let quantity = parseInt(box.getAttribute("data-quantity"));
        let discountPercentage = 0;

        if (quantity === 2) discountPercentage = 10;
        if (quantity === 3) discountPercentage = 15;
        if (quantity >= 4) discountPercentage = 20;

        // Calculate discounted per unit price
        let discountedTotalPrice = (originalPrice * quantity * (1 - discountPercentage / 100)).toFixed(2);
        let pricePerUnit = (discountedTotalPrice / quantity).toFixed(2);

        console.log(`📌 Quantity: ${quantity}, Discount: ${discountPercentage}%, Per Unit Price: $${pricePerUnit}`);

        let priceElement = document.createElement("div");
        priceElement.className = "bndlr-volume-price";
        priceElement.textContent = `Per unit: $${pricePerUnit}`;

        let existingPrice = box.querySelector(".bndlr-volume-price");
        if (existingPrice) existingPrice.remove();

        box.appendChild(priceElement);
        console.log("✅ Price element added:", priceElement);

        // Make the whole box trigger the existing Bundler app logic
        box.addEventListener("click", function (event) {
            event.preventDefault();

            let discountTag = box.querySelector(".bndlr-volume-saving-text");

            if (discountTag) {
                console.log("🛒 Triggering Bundler logic via discount tag...");
                discountTag.click(); // Simulate clicking the existing Bundler element
            } else {
                console.error("❌ Discount tag not found inside the box.");
            }
        });
    });

    console.log("✅ Custom Bundler logic applied.");
}

window.addEventListener("load", function () {
    setTimeout(waitForBundler, 1000);
});
